import { io } from "socket.io-client"
import secureLocalStorage from "react-secure-storage"

const connection_url = process.env.REACT_APP_SOCKET_URL

export const socket = io(connection_url, {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
})

export const registerSocket = () => {
  const loggedInUser = secureLocalStorage.getItem("admin_user")
  if (loggedInUser?.id) {
    socket.emit("register", loggedInUser.id)
    console.log("Socket registered for user:", loggedInUser.id)
  }
}

socket.on("connect", () => {
  console.log("Socket connected:", socket.id)
  registerSocket()
})

socket.on("disconnect", (reason) => {
  console.log("Socket disconnected:", reason)
})

socket.on("connect_error", (err) => {
  console.error("Connection error:", err.message)
})

socket.io.on("reconnect", (attempt) => {
  console.log("Socket reconnected after", attempt, "attempts")
  registerSocket()
})

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      if (socket.connected) {
        registerSocket()
      } else {
        socket.connect()
      }
    }
  })
}
